var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{ref:"image",attrs:{"height":"75","src":_vm.imageSrc,"alt":"your image"}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"imageInput","placeholder":_vm.placeholder},on:{"input":_vm.changeFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }